import { Box, Grid } from "@mui/material";
import { ClaimBasedComponent } from "components/ClaimBasedComponent";
import NavCard from "components/NavCard";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { ClaimResource } from "types/claimTypes";

const AccreditationPage = () => {
  const { formatMessage: t } = useIntl();
  const {
    qualificationsUrl,
    licensesUrl,
    licensureBodiesUrl,
    submissionAuthoritiesUrl,
    previouslyExportedReportsUrl,
  } = useGlobalContext();

  return (
    <Box my={4}>
      <Grid container spacing={4}>
        <ClaimBasedComponent requestedClaims={[ClaimResource.Qualifications]}>
          <Grid item xs={12} sm={4}>
            <NavCard
              title={t({ id: "accreditationBodies" })}
              url={qualificationsUrl()}
            />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.Licenses]}>
          <Grid item xs={12} sm={4}>
            <NavCard title={t({ id: "licensesLabel" })} url={licensesUrl()} />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.Licenses]}>
          <Grid item xs={12} sm={4}>
            <NavCard
              title={t({ id: "licensureBodies" })}
              url={licensureBodiesUrl()}
            />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.Licenses]}>
          <Grid item xs={12} sm={4}>
            <NavCard
              title={t({ id: "submissionAuthorities" })}
              url={submissionAuthoritiesUrl()}
            />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.SubmissionReport]}>
          <Grid item xs={12} sm={4}>
            <NavCard
              title={t({ id: "creditSubmissionReports" })}
              url={previouslyExportedReportsUrl()}
            />
          </Grid>
        </ClaimBasedComponent>
      </Grid>
    </Box>
  );
};

export default AccreditationPage;
